module.exports = __webpack_public_path__ + "img/whitesearch.e537fcfe.svg";